import React, { useEffect, useState } from "react";
import api from "../api/api"
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useAuth } from "../context/AuthContext";
import PropTypes from 'prop-types';
import { useTranslation } from "react-i18next";
const ConfirmModal = ({ biodata, isAccepted, fetchData }) => {
const { t } = useTranslation();


    const {user} = useAuth();
    const schema = yup.object({
        schedule: isAccepted ===  undefined ? yup
        .date()
        .required(t("Schedule date is required"))
        .min(new Date(), t("Schedule date must be today or later"))
        : yup.mixed().notRequired(),
        supplier_note: yup.string().notRequired(),
    });
    const {
      reset,
      handleSubmit,
      control,
      register,
      setError,
      clearErrors,
      formState: { errors },
    } = useForm({
      resolver: yupResolver(schema),
      //defaultValues: inputValues,
    });

     const [loadingSendInv,setloadingSendInv] = useState(false)
     const [message,setmessage] = useState(null)

    let text = {};
    if (isAccepted) {
        text = {
            title: t("Accept Booking for"),
            message: t("Are you sure you want to accept this book?"),
        };
    } else if (isAccepted == false) {
        text = {
            title: t("Reject Booking for"),
            message: t("Are you sure you want to decline this book?"),
        };
    } else {
        text = {
            title: t("Book Biodata"),
            message: t("Are you sure you want to book this biodata?"),
        };
    }
    

     
     const onSubmit = async(data) => {
        clearErrors();
        setmessage(null)
        let typeurl = "/supplier-accept-booking-interview/";
        if (loadingSendInv) return;
        setloadingSendInv(true);
        
        try {  
            data = {
                ...data,
                id: biodata.booking_id,
                is_accepted: isAccepted,
            }
            const response = await api.post(typeurl, data); 
            reset();
            setmessage(response.data.message)
            fetchData()
               
            

        } catch (error) {
       
           let  errorMessage = ""
            // Extract response code if available
            const responseCode = error.response ? error.response.status : "Unknown";
            console.log("Response Code:", responseCode);
            if (error?.response?.data) {
                
                 Object.entries(error.response.data).forEach(([key, values]) => {
                   //if (key !== "token" && key !== "agency") {
                     console.log(key, values);
                     errorMessage += `${values}\n`;
                   //}
                 });
               }
             
               // If no specific error was found, provide a default message
               if (!errorMessage) {
                
                 errorMessage = "An unknown error occurred.";
               }
               
               // Set the error message in React Hook Form
               setError("root", { type: "server", message: errorMessage });
   
        } finally {
            setloadingSendInv(false);
        }
    }
    
    useEffect(() => {
        const modalElement = document.getElementById("confirmModal");
    
        const handleModalShow = () => {
          setmessage(null); // Reset message when modal is opened
          clearErrors(); // Clear any existing errors
        };
    
        if (modalElement) {
          modalElement.addEventListener("show.bs.modal", handleModalShow);
        }
    
        return () => {
          if (modalElement) {
            modalElement.removeEventListener("show.bs.modal", handleModalShow);
          }
        };
      }, []);

    return (
        <div className="modal custom-modal modal-lg fade" id="confirmModal" role="dialog">
            <div className="modal-dialog modal-dialog-centered modal-md">
                <div className="modal-content">
                    <div className="modal-header border-0 pb-0">
                        <div className="form-header modal-header-title text-start mb-0">
                            <h4 className="mb-0">{text.title} {biodata?.name}</h4>

                        </div>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <form  onSubmit={handleSubmit(onSubmit)}>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-md-12">
                                        
                                    <div className="form-group">
                                        <label>{text.message}</label>
                                    </div>
                                    <div className="input-block mb-3">
                                        <label>{t("Notes")}</label>
                                        <textarea
                                            {...register("supplier_note")}
                                            className="form-control"
                                            placeholder={t("Enter Notes")}
                                        ></textarea>
                                        <small>{errors?.notes?.message}</small>
                                    </div>
                                                                           
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                        <small  style={{color:"green"}}> {message && <p>{message}</p>}</small>
                        <small  style={{color:"red"}}> {errors.root && <p>{errors.root.message}</p>}</small>
                            <button type="button" data-bs-dismiss="modal" className="btn btn-back cancel-btn me-2">{t("Cancel")}</button>
                            <button type="submit"  className="btn btn-primary " 
                            disabled={loadingSendInv} 
                            >{t("Yes")}
                            {loadingSendInv && <i className="fa-solid fa-spinner fa-spin" style={{margin: "0 10px"}}></i> }
                            </button>
                            
                        </div>
                    </form>
                </div>
            </div>
        </div>
    ); 
};
ConfirmModal.propTypes = {
    biodata: PropTypes.object.isRequired,
    isAccepted: PropTypes.bool,
    fetchData: PropTypes.func,
  };
export default ConfirmModal;
